import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { getCustomersExtraInformationsByCustomerId } from "../../services/customerExtraInformation";
import { baseURL, tenantId } from "../../config/api";
import Button from "../../components/Button";
import TermsAndConditionsPopup from "./TermsAndConditionsPopup";
import axios from "axios";
import SignatureCanvas from 'react-signature-canvas';
import { branchTimezone } from "../../utils/summaryCalculation";
import useConfirm from "../../hooks/useConfirm";
import { getIdTypes } from "../../services/idType";
import usePleaseWait from "../../hooks/usePleaseWait";
import useWebData from "../../hooks/useWebData";
import useQuotes from "../../hooks/useQuotes";
import moment from "moment";
import { confirmBooking, getReservationSummary } from "../../services/rental";

type ExtraInformation = {
    id: number;
    idNumber: string;
    issueDate: string;
    exprationDate: string;
    filePath: string;
    idTypeId: string;
    customerId: number;
    type: string;
};

type Props = {
    vehicleClassId: string;
    branchId: string;
    formattedCreatedAt: string;
    pickupDate: string;
    pickupTime: string;
    returnDate: string;
    returnTime: string;
    pickupLocation: string;
    returnLocation: string;
    locations: any[];
    customerId: number;
    localAddress: string;
    confirmSignatureURL: any;
    setConfirmSignatureURL: (value: any) => void;
    reservation: any;
    checkExtraValue: any[];
    selectedVehicleClass: any;
    securityDepositAmount: number;
    setCurrentPage: () => void;
    setPrimaryKey: (value: number) => void;
    customerData: any | null;
    setReservation: (value: any) => void;
};

export default function Confirm({
    vehicleClassId,
    branchId,
    formattedCreatedAt,
    pickupDate,
    pickupTime,
    returnDate,
    returnTime,
    pickupLocation,
    returnLocation,
    locations,
    customerId,
    localAddress,
    confirmSignatureURL,
    setConfirmSignatureURL,
    reservation,
    checkExtraValue,
    selectedVehicleClass,
    securityDepositAmount,
    setCurrentPage,
    setPrimaryKey,
    customerData,
    setReservation
}: Props) {
    const { webData }: any = useWebData();
    const { setOpen, setQuoteFormType }: any = useQuotes();
    const { setPleasWaitPopup }: any = usePleaseWait();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
    const [type, setType] = useState<any[]>([]);
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [Street, setStreet] = useState<string>("");
    const [street2, setStreet2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [zip, setZip] = useState<string>("");
    const [birthday, setBirthday] = useState("");

    let signaturePadRef = useRef<SignatureCanvas>(null);
    const [pickupLocationName, setPickupLocationName] = useState<string>("");
    const [returnLocationName, setReturnLocationName] = useState<string>("");
    const [isChecked, setIsChecked] = useState(false);
    const [termConditionMessage, setTermConditionMessage] = useState<string>("");
    const [termConditionsPopup, setTermConditionsPopup] = useState(false);
    const [quoteOpen, setQuoteOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    let latestPickup = new Date();
    let latestReturn = new Date();
    if (pickupDate) latestPickup = new Date(pickupTime ? `${pickupDate}T${pickupTime}` : pickupDate);
    if (returnDate) latestReturn = new Date(returnTime ? `${returnDate}T${returnTime}` : returnDate);

    const UpdateTimezone = branchTimezone(formattedCreatedAt);

    useEffect(() => {
        const handler = (event: any) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setQuoteOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    useEffect(() => {
        if (locations.length > 0) setPickupLocationName(locations?.find((item: any) => item.id === parseInt(pickupLocation))?.locationName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations, pickupLocation])

    useEffect(() => {
        if (locations.length > 0) setReturnLocationName(locations?.find((item: any) => item.id === parseInt(returnLocation))?.locationName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations, returnLocation])

    useEffect(() => {
        if (customerData) {
            setFirstName(customerData?.firstName);
            setLastName(customerData?.lastName);
            setEmailAddress(customerData?.emailAddress);
            setPhoneNumber(customerData?.phoneNumber);
            setStreet(customerData?.street);
            setStreet2(customerData?.street2);
            setCity(customerData?.city);
            setState(customerData?.state);
            setCountry(customerData?.country);
            setZip(customerData?.zip);
            setBirthday(
                moment(customerData.birthday.split("T")[0], "YYYY-MM-DDTHH:mm:ss").format(
                    webData?.dateFormat?.replace(/yyyy/g, "YYYY")
                )

            );
        } else {
            setFirstName("");
            setLastName("");
            setEmailAddress("");
            setPhoneNumber("");
            setStreet("");
            setStreet2("");
            setCity("");
            setState("");
            setCountry("");
            setZip("");
            setBirthday("");
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData]);

    useEffect(() => {
        getCustomersExtraInformationsByCustomerId(customerId, tenantId)
            .then((response) => {
                setExtraRow(() =>
                    response?.filter((value: any) => value.idTypeId !== 0)
                        ?.map((item: ExtraInformation, index: number) => {
                            return {
                                id: index + 1,
                                idNumber: item.idNumber,
                                issueDate: moment(item.issueDate.split("T")[0], "YYYY-MM-DDTHH:mm:ss").format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY')),
                                exprationDate: moment(item.exprationDate.split("T")[0], "YYYY-MM-DDTHH:mm:ss").format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY')),
                                filePath: item.filePath,
                                idTypeId: item.idTypeId,
                                customerId: item.customerId,
                                type: item.id,
                            };
                        })
                )
            })
            .catch((error) => {
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    useEffect(() => {
        getIdTypes(tenantId)
            .then(data => {
                setType(data);
            })
            .catch((error) => {
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const converTheBase64IntoFileAndUploadToServer = (canvas: HTMLCanvasElement, callback: any) => {
        canvas.toBlob((blob) => {
            if (blob) {
                const formData = new FormData();
                formData.append("ImageFile", blob, 'signature.png');
                axios
                    .post(`${baseURL}reservationFile/upload`, formData, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                            "Content-Type": "multipart/form-data"
                        },
                        withCredentials: true,
                    })
                    .then((response) => {
                        callback(response.data);
                    })
                    .catch((error) => {
                        setPleasWaitPopup(false);
                        console.error("Error:", error);
                        callback("");
                    });
            } else {
                setPleasWaitPopup(false);
                console.error("Error: Blob is null");
                callback("");
            }
        }, 'image/png');
    }

    const uploadSignature = (canvas: HTMLCanvasElement): Promise<any> => {
        return new Promise((resolve, reject) => {
            converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
                if (imageFilePath) {
                    resolve({
                        attributeName: "Reservation",
                        fileName: imageFilePath,
                        tabName: "Confirm",
                        userId: 0,
                        createdDate: new Date(UpdateTimezone)?.toLocaleString()
                    });
                } else {
                    resolve(null);
                }
            });
        });
    };

    const confirmTheReservation = async () => {
        if (!isChecked) {
            setTermConditionMessage('You must accept the Terms & Conditions to proceed.');
            return;
        } else {
            setTermConditionMessage("");
        }

        setPleasWaitPopup(true);
        let hasInvalidDate = false;
        if (extraRow?.length !== 0) {
            extraRow?.forEach(async (item: ExtraInformation) => {
                const returnDateTime = new Date(moment(`${returnDate}T${returnTime}`, `${webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}THH:mm`).format('YYYY-MM-DDTHH:mm'));
                const exprationDate = new Date(item?.exprationDate);

                const pickupDateTime = new Date(pickupDate);
                const issuedDate = new Date(item.issueDate);

                if (exprationDate < returnDateTime) {
                    setConfirmData({
                        title: 'Warning',
                        summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the return date and time.`,
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                            callback();
                        }
                    });

                    setConfirmPopup(true);

                    hasInvalidDate = true;
                    setPleasWaitPopup(false);
                    return;
                }

                if (issuedDate > pickupDateTime) {
                    setConfirmData({
                        title: 'Warning',
                        summary: `The issued date for ID (${item.idNumber}) cannot be later than the pickup date and time.`,
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                            callback();
                        },
                    });

                    setConfirmPopup(true);
                    setPleasWaitPopup(false);
                    hasInvalidDate = true;
                    return;
                }
            })
        }

        if (selectedVehicleClass?.availableVehicles <= 0) {
            setPleasWaitPopup(false);
            setConfirmData({
                title: 'Warning',
                summary: "Vehilce Class is Not Available",
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                    callback();
                }
            });

            setConfirmPopup(true);
            return;
        }

        if (hasInvalidDate) return;

        let additionalValue: any[] = [];
        if (checkExtraValue?.length > 0) {
            await checkExtraValue?.forEach((item: any,) => {
                additionalValue = [...additionalValue, ...item?.additionalCharges];
            });
        }

        let files: any[] = [];

        const canvas = signaturePadRef.current?.getTrimmedCanvas();

        if (canvas && (canvas.width > 1 && canvas.height > 1)) {
            const file = await uploadSignature(canvas);
            if (file) {
                files.push(file);
            }
        }

        confirmBooking(
            {
                pickupDate: pickupDate + "T" + pickupTime,
                returnDate: returnDate + "T" + returnTime,
                branchId: branchId,
                pickupLocationId: pickupLocation,
                returnLocationId: returnLocation,
                isWalkInCustomer: false,
                vehicleClassId: vehicleClassId,
                wasSecurityDepositManuallyChanged: false,
                securityDepositAmount: securityDepositAmount,
                reservationAdditionalChargeDto: additionalValue?.map((item: any) => (
                    {
                        additionalChargeByBranchId: item?.additionalChargeBranchId,
                        quantity: item?.quantity,
                        basePrice: item?.basePrice
                    }
                )),
                reservationDiscountDto: [],
                mandatoryAdditionalChargesAmount: reservation?.mandatoryAdditionalChargesAmount ?? 0,
                locationFeePercentage: reservation?.locationFeePercentage ?? 0,
                taxPercentage: reservation?.taxPercentage ?? 0,
                governmentTaxPercentage: reservation?.governmentTaxPercentage ?? 0,
                customerId: customerId,
                localAddress: localAddress,
                fileUploadDataDto: files
            },
            "Open",
            0,
            tenantId
        )
            .then((data) => {
                saveProcessCompleted(data);
            })
            .catch((error) => {
                setConfirmData({
                    title: 'Warning',
                    summary: error.response.data,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);
                setPleasWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const saveProcessCompleted = (currentPrimaryKey: string) => {
        setPrimaryKey(parseInt(currentPrimaryKey));
        setCurrentPage();
        setPleasWaitPopup(false);

        getReservationSummary(parseInt(currentPrimaryKey), tenantId)
            .then((data) => {
                setReservation(data)
            })
            .catch((error) => {
                console.error(error);
                setReservation(null);
            })
    }

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };


    return (
        <>
            <div className="w-full md:pl-[20px] mt-4">
                <span className={`text-[14px] font-semibold inline-block mb-2`}>
                    Date & Time
                </span>
                <hr className={`w-full bg-[#E4E7EC]`} />
                <div className="w-full my-2">
                    <div className="grid grid-cols-2 gap-6">
                        <div className="space-y-4">
                            <div>
                                <span className={`text-xs font-medium`}>Pickup Date</span><br />
                                <span className={`text-xs font-medium`}>{moment(latestPickup).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}</span>
                            </div>

                            <div>
                                <span className={`text-xs font-medium`}>Return Date</span><br />
                                <span className={`text-xs font-medium`}>{moment(latestReturn).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}</span>
                            </div>

                            <div>
                                <span className={`text-xs font-medium`}>Pickup Location</span><br />
                                <span className={`text-xs font-medium`}>{pickupLocationName}</span>
                            </div>

                        </div>
                        <div className="space-y-4">
                            <div>
                                <span className={`text-xs font-medium`}>Pickup Time</span><br />
                                <span className={`text-xs font-medium`}>{format(new Date(latestPickup), "KK:mm a")}</span>
                            </div>

                            <div>
                                <span className={`text-xs font-medium`}>Return Time</span><br />
                                <span className={`text-xs font-medium`}>{format(new Date(latestReturn), "KK:mm a")}</span>
                            </div>

                            <div>
                                <span className={`text-xs font-medium`}>Return Location</span><br />
                                <span className={`text-xs font-medium`}>{returnLocationName}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span className={`text-[14px] font-semibold inline-block mb-2`}>
                    Selected Vehicle
                </span>
                <hr className={`w-full bg-[#E4E7EC]`} />
                <div className="flex flex-col md:flex-row justify-between p-2 my-2 w-full h-full min-h-max rounded-lg shadow-sm border gap-4">
                    {/* Image */}
                    <img
                        src={
                            selectedVehicleClass?.imagePath?.startsWith("data:image/png;base64,")
                                ? selectedVehicleClass?.imagePath
                                : `${baseURL}vehicleClassFile/Get?name=${selectedVehicleClass?.imagePath}`
                        }
                        alt="vehicle"
                        className="w-full md:w-[230px] rounded-md object-cover"
                    />

                    {/* Info */}
                    <div className="flex flex-col px-2 gap-1.5 w-full md:w-[34%]">
                        <span className="text-[16px] font-semibold">
                            {selectedVehicleClass?.vehicleLabel}
                        </span>

                        <div className="flex flex-col items-start gap-1.5 text-xs">
                            {selectedVehicleClass?.features
                                ?.sort((a: any, b: any) => a?.order - b?.order)
                                ?.map((feature: any, indexFeat: number) => (
                                    <div key={indexFeat} className="flex items-center gap-1 text-xs">
                                        <span>{feature?.label}</span>
                                    </div>
                                ))}
                        </div>
                    </div>

                    {/* Price */}
                    <div className="flex flex-col gap-1.5 w-full md:w-[25%]">
                        {selectedVehicleClass?.recommended && (
                            <div className="flex md:justify-end">
                                <span className="inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold text-[#039855] border bg-[#E4E7EC]">
                                    Recommended
                                </span>
                            </div>
                        )}

                        <div className="flex flex-col gap-1.5 text-left">
                            <p className="text-sm">
                                <span className="font-semibold">
                                    ${parseInt(selectedVehicleClass?.dailyRate)?.toFixed(2)}
                                </span>
                                <span className="text-sm font-normal">/Day</span>
                            </p>

                            <p className="text-sm">
                                <span className="font-semibold">
                                    ${Number(reservation?.totalBasePriceBeforeDiscount)?.toFixed(2)} total for{" "}
                                    {selectedVehicleClass?.days} Day
                                    {selectedVehicleClass?.hours > 0 &&
                                        ` and ${selectedVehicleClass?.hours} hours`}
                                </span>
                            </p>

                            <p className="text-xs font-normal">Excl. taxes & insurance(s)</p>
                        </div>
                    </div>
                </div>


                <span className={`text-[14px] font-semibold inline-block mb-2`}>
                    Customer Information
                </span>
                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className="w-full my-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">

                        <div className="order-1 md:order-none">
                            <span className="text-xs font-medium">First Name</span><br />
                            <span className="text-xs font-medium">{firstName}</span>
                        </div>
                        <div className="order-2 md:order-none">
                            <span className="text-xs font-medium">Last Name</span><br />
                            <span className="text-xs font-medium">{lastName}</span>
                        </div>


                        <div className="order-3 md:order-none">
                            <span className="text-xs font-medium">Email Address</span><br />
                            <span className="text-xs font-medium">{emailAddress}</span>
                        </div>
                        <div className="order-4 md:order-none">
                            <span className="text-xs font-medium">Phone Number</span><br />
                            <span className="text-xs font-medium">{phoneNumber}</span>
                        </div>


                        <div className="order-5 md:order-none">
                            <span className="text-xs font-medium">Street</span><br />
                            <span className="text-xs font-medium">{Street}</span>
                        </div>
                        <div className="order-6 md:order-none">
                            <span className="text-xs font-medium">Street 2</span><br />
                            <span className="text-xs font-medium">{street2}</span>
                        </div>


                        <div className="order-7 md:order-none">
                            <span className="text-xs font-medium">City</span><br />
                            <span className="text-xs font-medium">{city}</span>
                        </div>
                        <div className="order-8 md:order-none">
                            <span className="text-xs font-medium">State</span><br />
                            <span className="text-xs font-medium">{state}</span>
                        </div>


                        <div className="order-9 md:order-none">
                            <span className="text-xs font-medium">Zip</span><br />
                            <span className="text-xs font-medium">{zip}</span>
                        </div>
                        <div className="order-10 md:order-none">
                            <span className="text-xs font-medium">Country</span><br />
                            <span className="text-xs font-medium">{country}</span>
                        </div>


                        <div className="order-11 md:order-none">
                            <span className="text-xs font-medium">Birthday</span><br />
                            <span className="text-xs font-medium">{birthday}</span>
                        </div>
                    </div>
                </div>


                <span className={`text-[14px] font-semibold inline-block mb-2`}>
                    Extra Information
                </span>

                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className="w-full my-2">
                    <div className="w-full overflow-x-auto hidden md:block">
                        <table className="min-w-full">
                            <thead className="text-left bg-[#E4E7EC]">
                                <tr className="border-b">
                                    <th className="w-[15%] text-[12px] font-semibold mb-2 pr-1 py-2">Type</th>
                                    <th className="w-[25%] text-[12px] font-semibold mb-2 px-1 py-2">ID Number</th>
                                    <th className="w-[20%] text-[12px] font-semibold mb-2 px-1 py-2">Issued On</th>
                                    <th className="w-[20%] text-[12px] font-semibold mb-2 pl-1 py-2">Exp. Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {extraRow?.map((item, index) => (
                                    <tr key={index} className="border-b">
                                        <td className="pr-1 py-2 text-xs font-medium w-[15%]">
                                            {type?.find((value) => value?.id === parseInt(item?.idTypeId))?.name}
                                        </td>
                                        <td className="px-1 py-2 text-xs font-medium w-[25%]">{item?.idNumber}</td>
                                        <td className="px-1 py-2 text-xs font-medium w-[20%]">
                                            {item?.issueDate}
                                        </td>
                                        <td className="pl-1 py-2 text-xs font-medium w-[20%]">
                                            {item?.exprationDate}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile Alternative Layout */}
                    <div className="md:hidden space-y-4">
                        {extraRow?.map((item, index) => (
                            <div key={index} className="border p-4 rounded-lg shadow-sm text-sm bg-white">
                                <div className="flex justify-between">
                                    <span className="font-medium text-gray-600">Type:</span>
                                    <span className="text-gray-800">
                                        {type?.find((value) => value?.id === parseInt(item?.idTypeId))?.name}
                                    </span>
                                </div>
                                <div className="flex justify-between mt-2">
                                    <span className="font-medium text-gray-600">ID Number:</span>
                                    <span className="text-gray-800">{item?.idNumber}</span>
                                </div>
                                <div className="flex justify-between mt-2">
                                    <span className="font-medium text-gray-600">Issued On:</span>
                                    <span className="text-gray-800">{item?.issueDate}</span>
                                </div>
                                <div className="flex justify-between mt-2">
                                    <span className="font-medium text-gray-600">Exp. Date:</span>
                                    <span className="text-gray-800">{item?.exprationDate}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {
                        localAddress && (
                            <div className="mt-2">
                                <span className={`text-xs font-medium`}>Local Address</span><br />
                                <span className={`text-xs font-medium`}>{localAddress}</span>
                            </div>
                        )
                    }

                    <div className="mt-2">
                        <input
                            type="checkbox"
                            id="confirmationCheckbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />

                        <span className="text-sm">
                            &nbsp;By clicking here, I confirm that I accept the
                            <span
                                className="text-blue-500 hover:underline cursor-pointer"
                                onClick={() => setTermConditionsPopup(true)}
                            >
                                &nbsp;Terms & Conditions
                            </span>
                        </span>
                    </div>

                    {termConditionMessage && (
                        <div className="text-red-500 text-sm">{termConditionMessage}</div>
                    )}

                </div>

                <span className={`text-[14px] font-semibold inline-block mb-2`}>
                    Signatures
                </span>

                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className="w-full my-2">
                    <div>
                        <div
                            className={`w-full h-[150px] border border-dashed border-gray-400 bg-no-repeat bg-center bg-auto !border-b-4`}
                            style={{
                                backgroundImage: confirmSignatureURL
                                    ? `url('${baseURL}reservationFile/Get?name=${confirmSignatureURL?.fileName}')`
                                    : '',
                                borderBottomStyle: "solid",
                                borderBottomColor: webData?.websiteHeaderColor || "#f97316"
                            }}
                        >
                            <SignatureCanvas
                                ref={signaturePadRef}
                                penColor="#167AC3"
                                canvasProps={{
                                    className: "w-full h-[150px]",
                                }}
                            />
                        </div>

                        <i
                            className="bx bxs-eraser text-white bg-orange-500 text-[18px] px-[5px] py-[3px] rounded cursor-pointer mt-[5px]"
                            style={{
                                backgroundColor: webData?.websiteHeaderColor
                            }}
                            onClick={() => {
                                signaturePadRef.current?.clear();
                                if (confirmSignatureURL) {
                                    setConfirmSignatureURL(null);
                                }
                            }}
                        ></i>
                    </div>
                </div>

                <div className="w-full flex gap-2.5 items-center mt-6">
                    <Button
                        btnType="button"
                        name="Confirm Reservation"
                        height="10px"
                        isBorderBtn={false}
                        onClickHandler={confirmTheReservation}
                    />
                    <div ref={menuRef} className="relative">
                        <button
                            className="mb-3 px-6 pt-2.5 pb-2 flex items-center text-sm font-medium border border-gray-400 bg-gray-200 rounded-md cursor-pointer"
                            type="button"

                            onClick={() => setQuoteOpen(!quoteOpen)}
                        >
                            Quote {quoteOpen ? <span className={`material-symbols-outlined text-[25px] font-extralight`}>
                                keyboard_arrow_up
                            </span> : <span className={`material-symbols-outlined text-[25px] font-extralight`}>
                                keyboard_arrow_down
                            </span>}
                        </button>

                        {quoteOpen && (
                            <div className="origin-top-right absolute right-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
                                <div className="py-1">
                                    <button
                                        onClick={() => {
                                            setQuoteOpen(false);
                                            setQuoteFormType(1);
                                            setOpen(true);
                                        }}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100"
                                    >
                                        Create PDF
                                    </button>
                                    <button
                                        onClick={() => {
                                            setQuoteOpen(false);
                                            setQuoteFormType(2);
                                            setOpen(true);
                                        }}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100"
                                    >
                                        Send Email
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {
                termConditionsPopup && (
                    <TermsAndConditionsPopup
                        visible={termConditionsPopup}
                        setVisible={(value) => setTermConditionsPopup(value)}
                    />
                )
            }
        </>
    );
}